import React, { useState, useEffect, useRef } from "react";
import {getAllNotifications} from "../api.js";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const trackRef = useRef(null);

  useEffect(() => {
    let ignore = false;

    const loadNotifications = async () => {
      try {
          
        const response = await getAllNotifications();
        
        const data = response?.data || [];

        if (!ignore) {
          setNotifications(
            Array.isArray(data) ? data.filter((n) => n && n.text) : []
          );
        }
      } catch (error) {
        console.error("Error loading notifications:", error);
        if (!ignore) {
          setNotifications([]);
        }
      }
    };

    loadNotifications();

    return () => {
      ignore = true;
    };
  }, []);

  // Mousewheel se speed thoda control karo, animation ko break kiye bina
  const handleWheel = (e) => {
    if (!trackRef.current) return;
    e.preventDefault();

    // Scroll direction ke hisaab se animation speed temporarily badhao
    const currentDuration = e.deltaY > 0 ? "8s" : "40s";
    trackRef.current.style.animationDuration = currentDuration;

    clearTimeout(trackRef.current._resetTimer);
    trackRef.current._resetTimer = setTimeout(() => {
      if (trackRef.current) {
        trackRef.current.style.animationDuration = "25s";
      }
    }, 600);
  };

  if (notifications.length === 0) return null;

  return (
    <div
      className="w-full bg-[#FF5C00] py-8 overflow-hidden relative"
      style={{ height: "40px" }}
      onWheel={handleWheel}
    >
      <div
        ref={trackRef}
        className="marquee-track"
        style={{
          display: "flex",
          width: "max-content",
          height: "100%",
          alignItems: "center",
        }}
      >
        {/* List do baar render — seamless loop ke liye zaroori hai */}
        {[...notifications, ...notifications].map((n, idx) => (
          <span
            key={`${n._id || n.id}-${idx}`}
            className="text-white text-[12px] md:text-base font-semibold"
            style={{ whiteSpace: "nowrap", padding: "0 24px" }}
          >
            ● &nbsp; {n.text}
          </span>
        ))}
      </div>

      <style>{`
        .marquee-track {
          animation: scroll-left 25s linear infinite;
        }
        @keyframes scroll-left {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
};

export default Notifications;